import { INITIALIZE_DATA_SUCCESS } from '../constants';

const initialState = {
  offices: [],
  services: [],
  areas: [],
  undergrounds: [],
  schedules: [],
  fullServices: [],
  auxiliary: [],
  servicesCatalog: [],
};

const dataReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_DATA_SUCCESS:
      return {
        ...state,
        [action.payload.data]: action.payload.result,
      };
    default:
      return state;
  }
};

export default dataReducer;
